import { forwardRef } from "react";
import { GraduationCap, MapPin, UsersThree, Buildings, UsersFour } from "@phosphor-icons/react";

const Stat = ({ icon: Icon, value, label }) => (
  <div className="flex flex-col items-center">
    <span className="mb-1 grid h-9 w-9 place-items-center rounded-full bg-white/10 text-[#f2d9a6]"><Icon size={18} weight="duotone" /></span>
    <span className="font-heading text-2xl font-semibold leading-none text-white">{value}</span>
    <span className="mt-1 text-[11px] uppercase tracking-wide text-white/60">{label}</span>
  </div>
);

// Branded, snapshot-friendly infographic card for an institution or alumni group.
export const InviteCard = forwardRef(function InviteCard({ data }, ref) {
  if (!data) return null;
  const isInst = data.type === "institution";
  const subtitle = [data.location || data.country, isInst ? null : data.institution_name].filter(Boolean).join(" · ");
  return (
    <div ref={ref} style={{ width: 400 }} className="overflow-hidden rounded-3xl bg-[#14281d] font-sans text-white shadow-2xl" data-testid="invite-card">
      <div className="flex items-center justify-between px-6 pt-5">
        <div className="flex items-center gap-2">
          <span className="grid h-7 w-7 place-items-center rounded-lg bg-[#d4a24e] text-[#14281d]"><GraduationCap size={16} weight="fill" /></span>
          <span className="font-heading text-sm font-semibold tracking-tight">AlumniPulse™</span>
        </div>
        <span className="rounded-full bg-white/10 px-3 py-1 text-[11px] font-medium text-[#f2d9a6]">You're invited</span>
      </div>

      <div className="px-6 pb-2 pt-6 text-center">
        <div className="mx-auto mb-4 grid h-16 w-16 place-items-center overflow-hidden rounded-2xl bg-[#d4a24e]/15 ring-1 ring-[#d4a24e]/30">
          {data.logo_url
            ? <img src={data.logo_url} alt={data.name} className="h-full w-full object-cover" crossOrigin="anonymous" />
            : (isInst ? <Buildings size={28} weight="duotone" className="text-[#f2d9a6]" /> : <UsersThree size={28} weight="duotone" className="text-[#f2d9a6]" />)}
        </div>
        <h2 className="font-heading text-xl font-semibold leading-tight">{data.name}</h2>
        {subtitle && <p className="mt-1 flex items-center justify-center gap-1 text-xs text-white/60"><MapPin size={12} /> {subtitle}</p>}
        {data.description && <p className="mx-auto mt-3 line-clamp-2 max-w-[300px] text-[13px] leading-relaxed text-white/70">{data.description}</p>}
      </div>

      <div className="mt-4 flex items-center justify-center gap-8 border-t border-white/10 px-6 py-5">
        {isInst ? (
          <>
            <Stat icon={UsersThree} value={data.alumni_count ?? 0} label="Alumni" />
            <Stat icon={UsersFour} value={data.groups_count ?? 0} label="Groups" />
          </>
        ) : (
          <Stat icon={UsersThree} value={data.member_count ?? 0} label="Members" />
        )}
      </div>

      <div className="bg-[#d4a24e] px-6 py-3 text-center">
        <p className="font-heading text-sm font-semibold text-[#14281d]">Explore · Join · Contribute</p>
        <p className="text-[11px] font-medium text-[#14281d]/70">alumnipulse.net</p>
      </div>
    </div>
  );
});
